/* eslint-disable no-console */

import { register } from "register-service-worker";
import Vue from "vue";
import Toasted from "vue-toasted";
Vue.use(Toasted);

export function showUpdateToast(
  message = "Application has been updated, please refresh"
) {
  Vue.toasted.show(message, {
    position: "bottom-right",
    className: "toast-error",
    duration: 15000,
    action: {
      text: "Refresh",
      onClick: (event, toastObject) => {
        toastObject.goAway(0);
        window.location.href = "/";
      }
    },
    singleton: true
  });
}

if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      );
    },
    registered(instance) {
      console.log("Service worker has been registered!");
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated(instance) {
      console.log("Service worker has been updated!", instance);
      if (instance.waiting) {
        // console.log('Service worker has been registered. waiting!');
        instance.waiting.postMessage({ type: "SKIP_WAITING" });
        showUpdateToast();
      }
    },
    offline() {
      console.log("No internet connection found. App is running in offline.");
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    }
  });
}
